import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { normalizeMenuSchedule } from '~/services/api/contracts/normalizeMenuSchedule'

export const menuFieldsNormalizer = fieldNormalizer({
  prepare: normalizeMenuSchedule,
  trimmed: ['name'],
  blankToNull: ['description']
})
